/**
 * LPWEB-16416 — Paid Social PDP Carousel: Inspiration & Gifts Top Sellers
 *
 * Target: Product Bundle only (visible "You May Also Like" on G&I PDPs).
 * Does not hook New Product Bundle (Buy 2) or Product recommendations.
 *
 * Flow:
 *  1. Detect paid social traffic (UTM params, fbclid, ttclid)
 *  2. Persist detection to sessionStorage for session duration
 *  3. On qualifying Inspiration & Gifts PDPs, clone pre-rendered G&I
 *     top-seller cards from #paid-social-gni-source into the Product Bundle scroller.
 *     Clone (do not move): source cards already ran product-form connectedCallback;
 *     moving them would add a second submit listener and double Add +.
 *  4. Fallback silently to the default bundle list if fewer than 3 source cards
 */

(function () {
  'use strict';

  const SESSION_KEY  = 'lp:paid_social_session';
  const MIN_PRODUCTS = 3;

  function isPaidSocialUrl() {
    try {
      const p      = new URLSearchParams(window.location.search);
      const medium = (p.get('utm_medium') || '').toLowerCase().replace(/[-_\s]/g, '');
      const source = (p.get('utm_source') || '').toLowerCase();

      const MEDIUMS = ['paidsocial', 'social', 'cpc', 'paid'];
      const SOURCES = ['facebook', 'instagram', 'meta', 'tiktok', 'pinterest', 'snapchat'];

      if (MEDIUMS.includes(medium))                              return true;
      if (medium && SOURCES.some(s => source.includes(s)))      return true;
      if (p.has('fbclid') || p.has('ttclid') || p.has('igshid')) return true;
    } catch (_) {}
    return false;
  }

  function initSession() {
    try {
      if (isPaidSocialUrl()) sessionStorage.setItem(SESSION_KEY, '1');
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (_) {
      return isPaidSocialUrl();
    }
  }

  function getConfig() {
    const el = document.getElementById('paid-social-gni-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[LPWEB-16416] Config parse error', e);
      return null;
    }
  }

  function getScroller(root) {
    return (
      root.querySelector('.product-list__inner--scroller') ||
      root.querySelector('.product-list__inner')
    );
  }

  function findBundleRoot() {
    return document.querySelector('[data-lp-gni-bundle]');
  }

  function getSourceWrappers() {
    const source = document.getElementById('paid-social-gni-source');
    if (!source) return [];
    return Array.from(source.querySelectorAll('.js-gni-product-wrapper'));
  }

  function applyFromSource(root, items) {
    const scroller = getScroller(root);
    if (!scroller) return false;

    const clones = items.map(item => {
      const clone = item.cloneNode(true);
      // Hidden source cards already ran product-form setup. cloneNode copies
      // data-reveal-bound / data-sticky-remove-bound, so the clone would skip
      // hover→Remove and the remove click. In Cart has no type, so it submits.
      clone.querySelectorAll('[data-reveal-bound]').forEach(el => {
        delete el.dataset.revealBound;
      });
      clone.querySelectorAll('[data-sticky-remove-bound]').forEach(el => {
        delete el.dataset.stickyRemoveBound;
      });
      clone.querySelectorAll('.main-In-cart').forEach(btn => {
        btn.setAttribute('type', 'button');
      });
      return clone;
    });
    items.forEach(item => item.remove());
    scroller.querySelectorAll('.js-gni-product-wrapper').forEach(el => el.remove());
    clones.forEach(clone => scroller.appendChild(clone));
    scroller.style.setProperty('--product-item', String(clones.length));

    Object.assign(root.dataset, {
      gniCarousel: 'true',
      gniSource:   'gni-top-sellers',
      gniCount:    String(clones.length)
    });

    return true;
  }

  function init() {
    if (window.themeVariables?.settings?.pageType !== 'product') return;
    if (!initSession()) return;

    const cfg = getConfig();
    if (!cfg?.isGiftsInspirationProduct) return;

    const bundleRoot = findBundleRoot();
    if (!bundleRoot) {
      console.info('[LPWEB-16416] No Product Bundle on this PDP — nothing to override.');
      return;
    }

    const sourceItems = getSourceWrappers();
    if (sourceItems.length < MIN_PRODUCTS) {
      console.info('[LPWEB-16416] Fallback to default Product Bundle — fewer than', MIN_PRODUCTS, 'G&I top sellers.');
      return;
    }

    if (applyFromSource(bundleRoot, sourceItems)) {
      document.dispatchEvent(new CustomEvent('lp:gni-carousel-applied', {
        detail: {
          productId: cfg.productId,
          count: Number(bundleRoot.dataset.gniCount),
          source: 'gni-top-sellers'
        }
      }));
      console.info('[LPWEB-16416] Product Bundle overridden ✓', bundleRoot.dataset.gniCount, 'G&I top sellers');
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
